<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi :md="three ? 9 : 12">
          <Title tag="h2">{{ title }}</Title>
          <Content
            v-if="singleTypeProjects.content"
            :content="singleTypeProjects.content"
          />
          <div v-if="!route.query.date">
            <Paginacion
              :datosTmp="datosTmp"
              @passPaginado="passPaginado"
              sustantivo="Registros"
              textoNulo="No hay registros de eventos de magnitud mayor o igual a M4.5"
            >
              <template v-slot:controls>
                <div>
                  Filtro:
                </div>
                <div>
                  <select
                    v-model="year"
                    aria-controls="igp-table"
                    class="custom-select custom-select-sm"
                  >
                    <option
                      :key="i"
                      v-for="(n, i) in new Date().getFullYear() - 2014"
                      :value="i + 2015"
                      >{{ i + 2015 }}</option
                    >
                  </select>
                </div>
                <div style="margin-left:auto">
                  <select
                    v-model="mes"
                    name="mes"
                    aria-controls="igp-table"
                    class="custom-select custom-select-sm "
                  >
                    <option value="20">Todos</option>
                    <option value="0">Enero</option>
                    <option value="1">Febrero</option>
                    <option value="2">Marzo</option>
                    <option value="3">Abril</option>
                    <option value="4">Mayo</option>
                    <option value="5">Junio</option>
                    <option value="6">Julio</option>
                    <option value="7">Agosto</option>
                    <option value="8">Septiembre</option>
                    <option value="9">Octubre</option>
                    <option value="10">Noviembre</option>
                    <option value="11">Diciembre</option>
                  </select>
                </div>
              </template>

              <template v-slot:datosViwer>
                <TableUi style="width:100%">
                  <template v-slot:header>
                    <tr>
                      <th colspan="6">
                        Listado de reportes y registros acelerométricos (mayor e
                        igual a M.4.5)
                      </th>
                    </tr>
                    <tr>
                      <th>Número de reporte</th>
                      <th>Fecha y hora</th>
                      <th>Magnitud</th>
                      <th>Profundidad</th>
                      <th>Ubicación</th>
                      <th>Acciones</th>
                    </tr>
                  </template>
                  <template v-slot:body>
                    <tr :key="i" v-for="(dato, i) of datos">
                      <td>
                        <span v-if="numeroReporte(dato)">
                          {{ numeroReporte(dato) }}
                        </span>
                        <span v-else style="color: gray; text-align: center;">
                          -
                        </span>
                      </td>
                      <td>
                        {{ fechaLocal(dato.fec) }}
                      </td>
                      <td>
                        {{ dato.mag }}
                      </td>
                      <td>{{ dato.pro }} km.</td>
                      <td>
                        {{ parseGeo(dato) }}
                      </td>
                      <td class="table_actions">
                        <Button
                          v-if="dato.mag < 4.5"
                          tag="button"
                          theme="disabled"
                        >
                          No se tiene data
                        </Button>
                        <Button
                          v-if="dato.mag >= 4.5"
                          tag="button"
                          @click="verEvento(dato)"
                          theme="primary"
                        >
                          <Icon svg="watch" />
                        </Button>
                        <Button
                          v-if="dato.mag < 4.5"
                          tag="button"
                          theme="disabled"
                        >
                          No tiene reporte
                        </Button>
                        <Button
                          v-if="dato.mag >= 4.5"
                          tag="a"
                          :href="downloadPDF(dato)"
                          theme="primary"
                          download
                        >
                          <Icon svg="download" />
                        </Button>
                      </td>
                    </tr>
                  </template>
                </TableUi>
              </template>
            </Paginacion>
          </div>
          <div v-if="route.query.date">
            <FichaRegistroAcelerometrico
              v-if="viendoEvento.datos"
              :parametros="viendoEvento.datos"
            >
              <template v-slot:body>
                <Row v-if="viendoEvento.datos.num">
                  <ColumnUi md="6" xs="12">
                    <p>
                      <b>Fecha y hora local</b>:{{
                        fechaHora(viendoEvento.datos.fec)
                      }}
                    </p>
                  </ColumnUi>
                  <ColumnUi md="6" xs="12">
                    <p>
                      <b>Latitud y Longitud</b>:
                      {{ parseGeo(viendoEvento.datos) }}
                    </p>
                  </ColumnUi>
                </Row>
                <Row v-if="viendoEvento.datos.num">
                  <ColumnUi md="6" xs="12">
                    <p><b>Profundidad</b>:{{ viendoEvento.datos.pro }} km.</p>
                  </ColumnUi>
                  <ColumnUi md="6" xs="12">
                    <p><b>Intensidad</b>: {{ viendoEvento.datos.int }}</p>
                  </ColumnUi>
                </Row>
                <Button
                  tag="button"
                  @click="openModal(viendoEvento.datos)"
                  theme="primary"
                >
                  Ver ubicación en mapa
                </Button>
                <Button
                  v-if="hrefPDF(viendoEvento.datos)"
                  tag="a"
                  target="_blank"
                  :href="hrefPDF(viendoEvento.datos)"
                  theme="primary"
                  class="second-button"
                >
                  Reporte sísmico
                </Button>
                <br /><br />
                <Row>
                  <ColumnUi xs="12">
                    Estaciones percibidas por el evento
                  </ColumnUi>
                </Row>
                <div style="overflow:auto">
                  <TableUi
                    style="width:100%"
                    :extraStyle="color(viendoEvento.datos)"
                  >
                    <template v-slot:header>
                      <tr :class="colorHeader(viendoEvento.datos)">
                        <th :key="i" v-for="(cab, i) of cabecera">
                          {{ cab.label }}
                        </th>
                      </tr>
                    </template>
                    <template v-slot:body>
                      <tr :key="i" v-for="(dato, i) of datos">
                        <td>
                          {{
                            dato.nom.toLocaleUpperCase().slice(0, 1) +
                              dato.nom.slice(1)
                          }}
                        </td>
                        <td>
                          {{ dato.cod.toLocaleUpperCase()
                          }}<span v-if="dato.typ === 'sis'">A</span>
                        </td>
                        <td>
                          {{ parseGeo(dato) }}
                        </td>
                        <td>
                          <div class="table_datos">
                            <Button
                              tag="button"
                              @click="
                                openEspectro(
                                  dato.cod.toLocaleUpperCase(),
                                  dato.net,
                                  dato.typ
                                )
                              "
                              theme="primary"
                              class="btn__actions"
                            >
                              <Icon svg="watch" />
                            </Button>

                            <Button
                              v-if="dato.typ === 'sis'"
                              tag="a"
                              @click="
                                downloadData(
                                  dato.cod.toLocaleUpperCase(),
                                  dato.net
                                )
                              "
                              :href="
                                `${href}_${dato['cod'].toUpperCase()}A_${
                                  dato['net']
                                }.txt`
                              "
                              target="_blank"
                              download
                              theme="primary"
                              title="descargar"
                              class="btn__actions"
                            >
                              <Icon svg="download" />
                            </Button>
                            <Button
                              v-if="dato.typ != 'sis'"
                              tag="a"
                              @click="
                                downloadData(
                                  dato.cod.toLocaleUpperCase(),
                                  dato.net
                                )
                              "
                              :href="
                                `${href}_${dato['cod'].toUpperCase()}_${
                                  dato['net']
                                }.txt`
                              "
                              target="_blank"
                              download
                              theme="primary"
                              title="descargar"
                              class="btn__actions"
                            >
                              <Icon svg="download" />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </TableUi>
                </div>
              </template>
            </FichaRegistroAcelerometrico>
          </div>
        </ColumnUi>
        <ColumnUi md="3" v-if="three">
          <List marked>
            <li>
              <router-link
                v-if="view != '/informacion-acelerometrica'"
                :to="'/informacion-acelerometrica'"
              >
                Información Acelerométrica
              </router-link>
              <span v-else>
                Información Acelerométrica
              </span>
            </li>
            <li>
              <router-link
                v-if="view != '/red-acelerometrica'"
                :to="'/red-acelerometrica'"
              >
                Red acelerométrica Nacional
              </router-link>
              <span v-else>Red acelerométrica Nacional</span>
            </li>
            <li>
              <router-link
                v-if="view != '/reportes-registros-acelerometricos'"
                :to="'/reportes-registros-acelerometricos'"
              >
                Reportes y registros acelerométricos
              </router-link>
              <span v-else>Reportes y registros acelerométricos</span>
            </li>
            <li>
              <router-link
                v-if="view != '/sismos-historicos'"
                :to="'/sismos-historicos'"
              >
                Sismos Históricos
              </router-link>
              <span v-else>Sismos Históricos</span>
            </li>
          </List>
        </ColumnUi>
      </Row>
    </Container>
    <Modal :showModal="showModal" centered v-on:close="close">
      <template v-slot:header>
        <h3>Ubicación del reporte: {{ numeroReporte(eventoAbierto) }}</h3>
      </template>
      <template v-slot:body>
        <Mapa
          v-if="geoJSON.datos.length"
          :altoAncho="'height: 60vh;width:100%;margin:auto'"
          elId="mapa2"
          :datosGeoJson="geoJSON.datos"
          :datosaddGeoJon="addGeoJon.datos"
        >
        </Mapa>
      </template>
    </Modal>
    <Modal :showModal="showModalEspectro" centered v-on:close="close">
      <template v-slot:header>
        <h3>Espectro de respuesta</h3>
      </template>
      <template v-slot:body>
        <img :src="pathEspectro" :alt="pathEspectro" />
      </template>
    </Modal>
  </main>
</template>
<script>
import { getRegistros } from "@/registrosAcelerometricos.js";
import { useRoute, useRouter } from "vue-router";
import Container from "@/components/ui/objects/Container.vue";
import Mapa from "@/components/ui/objects/Mapa.vue";
import FichaRegistroAcelerometrico from "@/components/ui/objects/FichaRegistroAcelerometrico.vue";
import Title from "@/components/ui/atoms/Title.vue";
import Trail from "@/components/common/Trail.vue";
import Button from "@/components/ui/atoms/Button.vue";
import TableUi from "@/components/ui/objects/TableUi.vue";
import Modal from "@/components/common/Modal.vue";
import Content from "../components/common/Content.vue";
import Row from "../components/ui/atoms/Row.vue";
import ColumnUi from "../components/ui/atoms/ColumnUi.vue";
/* import List from '../components/ui/objects/List.vue'; */
/* import Input from "@/components/ui/atoms/Input" */
import { getSection } from "@/interface-data.js";
import Paginacion from "@/components/ui/objects/Paginacion";
import { getGeodata } from "@/getGeodata";
import { reactive, ref, watch, onBeforeMount } from "vue";
import moment from "moment-timezone";
import List from "@/components/ui/objects/List.vue";
import Icon from "@/components/ui/atoms/Icon";

export default {
  components: {
    Trail,
    Container,
    TableUi,
    Title,
    Button,
    Content,
    Row,
    ColumnUi,
    Paginacion,
    Modal,
    Mapa,
    FichaRegistroAcelerometrico,
    List,
    Icon,
  },
  emits: ["setOverlay"],
  setup(props, { emit }) {
    const filter = ref("");

    const type = useRoute()
      .path.split("/")
      .slice(-1)[0];
    const allProjects = getRegistros(process.env.VUE_APP_PREFIX);
    const singleTypeProjects = allProjects.find(
      (projects) => projects.slug == type
    );
    const title = singleTypeProjects.title;
    const projectTypes = [];
    allProjects.forEach((e) => {
      projectTypes.push({ slug: e.slug, title: e.type });
    });

    let filteredProjects =
      (singleTypeProjects && reactive({ data: singleTypeProjects.data })) || [];
    const getQuery = (query) => {
      filter.value = query;
      filterProjects(query);
    };
    function filterProjects(query) {
      filteredProjects.data = singleTypeProjects.data.filter((project) =>
        project.title.toLowerCase().includes(query.toLowerCase())
      );
    }

    const view = useRoute().fullPath;
    const three = getSection(process.env.VUE_APP_PREFIX, view);

    const cabecera = ref([]);
    const datosTmp = ref([]);
    const datos = ref([]);

    const passPaginado = (paginado) => {
      datos.value = paginado;
    };

    let router = useRouter();
    const route = useRoute();
    let reportes = [];
    let viendoEvento = reactive({ datos: [] });
    const href = ref("");
    let pathDownload = ref("");

    onBeforeMount(async () => {
      try {
        if (route.query.date) {
          if (Object.keys(route.query).length) {
            reportes = await getGeodata.getEstaciones(route.query.date);
            viendoEvento.datos = reportes.Datos.event;
            cabecera.value = reportes.Cabecera;
            datos.value = reportes.Datos.stats;
            href.value = `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/ran/file/${viendoEvento.datos.num}_${route.query.date}`;
          } else {
            reportes = await getGeodata.getEventos(
              new Date().getFullYear(),
              20
            );
            cabecera.value = reportes.Cabecera;
            datosTmp.value = reportes.Datos;
          }
        } else {
          reportes = await getGeodata.getEventos(new Date().getFullYear(), 20);
          cabecera.value = reportes.Cabecera;
          datosTmp.value = reportes.Datos;
        }
      } catch (error) {
        console.log(error);
      }
    });

    const numeroReporte = (obj) => {
      return obj.num
        ? `IGP/ACELDAT-PERU ${obj.num
            .toString()
            .slice(0, 4)}-${obj.num.toString().slice(4)}`
        : "";
    };
    const parseGeo = (obj) => {
      const { coordinates } = obj.pos;
      const lat = parseFloat(coordinates[1]).toFixed(3);
      const long = parseFloat(coordinates[0]).toFixed(3);
      return `${lat}, ${long}`;
    };

    const fechaHora = (obj) => {
      let local = moment(obj)
        .tz("America/Lima")
        .format("DD/MM/YYYY, HH:mm:ss");
      return `${local}`;
    };

    const verEventoMapa = async (entry) => {
      try {
        reportes = await getGeodata.getEstaciones(entry.val);
        openModal(entry);
      } catch (error) {
        console.log(error);
      }
    };

    const fechaLocal = (obj) => {
      const [dd, mm, yyyy, hh, mmm, ss] = obj.match(/\d+/g);
      const fhUTC = `${yyyy}-${mm}-${dd}T${hh}:${mmm}:${ss}.000Z`;
      return moment(fhUTC)
        .tz("America/Lima")
        .format("DD/MM/YYYY, HH:mm:ss");
    };

    const verEvento = (entry) => {
      viendoEvento.datos = entry;
      router.push({ query: { date: entry.val } });
    };

    let showModalEspectro = ref(false);
    let pathEspectro = ref("");

    // Open Modal Espectro
    const openEspectro = (cod, net, type) => {
      const codeUpper = cod.toUpperCase();
      const fileString =
        type === "sis"
          ? `${viendoEvento.datos.num}_${route.query.date}_${codeUpper}A_${net}.webp`
          : `${viendoEvento.datos.num}_${route.query.date}_${codeUpper}_${net}.webp`;
      pathEspectro.value = `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/ran/file/${fileString}`;
      showModalEspectro.value = true;
    };

    const downloadData = (cod, net) => {
      pathDownload.value = `${
        process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC
      }/ran/file/${viendoEvento.datos.num}_co${
        route.query.date
      }_${cod.toUpperCase()}_${net}.txt`;
    };

    let showModal = ref(false);
    watch(showModal, () => {
      emit("setOverlay", showModal.value);
    });
    let showProject = reactive({ data: {} });
    let tempGeoJson = [];
    const openModal = (obj) => {
      if (!obj.val) {
        let val = obj.fec
          .replace(/-|:/g, "")
          .replace("T", "_")
          .split(".")[0];
        obj = { ...obj, val };
      }
      tempGeoJson = [];
      mostrarEvento(obj);
      showModal.value = true;
    };
    const close = () => {
      showModal.value = false;
      showModalEspectro.value = false;
    };
    let eventoAbierto = ref({});
    let geoJSON = reactive({ datos: [] });
    let addGeoJon = reactive({ datos: [] });

    const mostrarEvento = async (obj) => {
      eventoAbierto.value = obj;
      const res = await getGeodata.getEstaciones(obj.val);
      const estaciones = res.Datos.stats;
      const featureChecked = estaciones.map((item) => {
        const properties = {
          cod: item.cod.toUpperCase(),
          nom: item.nom.charAt(0).toUpperCase() + item.nom.slice(1),
          type: "stations",
        };
        return {
          properties,
          ...item.pos,
        };
      });
      tempGeoJson = featureChecked;
      agregarEvento([res.Datos.event]);
    };
    const agregarEvento = async (aGeoJson) => {
      var featureChecked = [];
      aGeoJson.forEach((item) => {
        item.pos["properties"] = {};
        item.pos["properties"]["magn"] = item.mag;
        item.pos["properties"]["prof"] = item.pro;
        item.pos["properties"]["date"] = fechaHora(item.fec);
        item.pos["properties"]["type"] = "events";
        featureChecked.push(item.pos);
      });
      geoJSON.datos = [...tempGeoJson, ...featureChecked];
      addGeoJon.datos = [...tempGeoJson, ...featureChecked];
    };
    const hrefPDF = (entry) => {
      try {
        return `https://www.igp.gob.pe/servicios/centro-sismologico-nacional/evento/${entry.num
          .toString()
          .slice(0, 4)}-${entry.num.toString().slice(4)}`;
      } catch (error) {
        return false;
      }
    };

    const downloadPDF = (entry) => {
      try {
        return `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/ran/file/${entry.num}_${entry.val}.pdf`;
      } catch (error) {
        return `false`;
      }
    };
    const color = (obj) => {
      const magnitud = obj.mag;
      if (magnitud < 4.5) return "border-bottom: 1px solid #009900 !important;";
      if (magnitud < 6) return "border-bottom: 1px solid #FFDD00 !important;";
      return "border-bottom: 1px solid #E20000 !important;";
    };
    const colorHeader = (obj) => {
      let magnitud = obj.mag;
      if (magnitud < 4.5) {
        return "verde";
      }
      if (magnitud >= 4.5 && magnitud < 6) {
        return "amarillo";
      }
      if (magnitud >= 6) {
        return "rojo";
      }
    };
    let year = ref(new Date().getFullYear());
    let mes = ref(20);
    watch(year, () => {
      nuevosDatos();
    });
    watch(mes, () => {
      nuevosDatos();
    });
    const nuevosDatos = async () => {
      try {
        reportes = await getGeodata.getEventos(year.value, mes.value);
        cabecera.value = reportes.Cabecera;
        datosTmp.value = reportes.Datos;
      } catch (error) {
        console.log(error);
      }
    };
    return {
      fechaLocal,
      year,
      mes,
      downloadPDF,
      colorHeader,
      hrefPDF,
      verEventoMapa,
      showModalEspectro,
      openEspectro,
      downloadData,
      pathEspectro,
      href,
      route,
      viendoEvento,
      eventoAbierto,
      geoJSON,
      addGeoJon,
      parseGeo,
      verEvento,
      fechaHora,
      numeroReporte,
      title,
      filteredProjects,
      showModal,
      showProject,
      openModal,
      close,
      projectTypes,
      type,
      getQuery,
      singleTypeProjects,
      three,
      datos,
      cabecera,
      datosTmp,
      passPaginado,
      reportes,
      color,
      moment,
    };
  },
};
</script>
<style scoped>
.text-strong {
  color: #0000af;
}
.table_datos {
  display: flex;
  align-items: stretch;
}

.btn__actions {
  width: 45px;
  height: 45px;
  display: flex;
  justify-self: center;
  align-items: center;
}

.table_actions {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
</style>
